import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import useConfigs from "../../hooks/useConfigs";

// ##### Estilos #####
const ContListNews = styled.div`
  grid-column: 1 / span 2;
  display: flex;
  justify-content: center;
  align-items: center;

  ul {
    width: 100% !important;
  }

  ul li {
    width: 100%;
    padding: 1.5rem 1rem;
    border-top: 2px solid rgb(197, 197, 197);
    cursor: pointer;
  }

  ul li p {
    color: ${(props) =>
      props.themeSelected === "light"
        ? props.theme.azulPpal
        : props.theme.grisTipografia
    };
    font-weight: 600;
    width: 100%;
    text-decoration: none;
    font-size: ${(props) => 14 * props.fontSizeMultiplier};
  }
`;

export const NewsList = ({ data, id }) => {
  const { fontSizeMultiplier, theme, themeSelected } = useConfigs();
  const history = useHistory();

  return (
    <div className="col-md-12">
      <ContListNews
        fontSizeMultiplier={fontSizeMultiplier} 
        theme={theme}
        themeSelected={themeSelected}>
        <ul>
          {data
            .filter((item) => item.id !== id)
            .slice(4, 10)
            .map((item) => (
              <li
                key={item.id}
                onClick={() =>
                  history.push({
                    pathname: "/unanoticia",
                    state: { noticia: item, noticias: data },
                  })
                }
              >
                <p>{item.titulo}</p>
              </li>
            ))}
        </ul>
      </ContListNews>
    </div>
  );
};

NewsList.propTypes = {
  data: PropTypes.array,
  id: PropTypes.number,
};
